import { getSeasonYears } from "@/lib/dormant-season/helpers";
import { isHiringSeasonDormant } from "@/lib/dormant-season/resolve";

function seasonNotice(now: Date): string | undefined {
  if (!isHiringSeasonDormant("express-interest")) {
    return undefined;
  }

  const { current, next } = getSeasonYears(now);
  return `Matching has ended for the ${current} hiring season. Expressing interest reopens in early ${next}`;
}

export function getExpressInterestDormantTooltip(
  now: Date,
): string | undefined {
  const notice = seasonNotice(now);
  return notice
    ? `${notice} — in the meantime you can save this school, set a job alert, or apply to their open roles.`
    : undefined;
}

export function getExpressInterestDormantSidebarNotice(
  now: Date,
): string | undefined {
  const notice = seasonNotice(now);
  return notice ? `${notice}.` : undefined;
}
